/* eslint-disable @typescript-eslint/naming-convention */
export const KEYCODES = {
	DOWN: 40,
	ENTER: 13,
	ESCAPE: 27,
	SPACE: 32,
	UP: 38,
};
